<template>
  <div class="modal fade" id="delivery-product-add-modal" role="dialog" @click="$emit('close')" :style="{ 'z-index': zIndex || 1050 }">
    <div class="modal-dialog modal-xl" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="panel products-table" ref="deliveryProductModal" style="position: relative">
            <table-delivery-product-add
              :url="apiUrl"
              :isAmazonReturn="true"
              :iconUrls="iconUrls"
              :extraUrl="['Product/get-image-name']"
              :extraUrlMode="true"
              :columns="deliveryProductColumns"
              :isSearchable="true"
              :needExtraData="true"
              :loadingTableMode="true"
              :clientMode="true"
              :checkedItems="checkedItems"
              :isShowBtnBulkCreate="true"
              :selectedProducts="deliverySelectedProducts"
              ref="deliveryProductAddTable"
              @countData="countData = $event"
              @extraData="extraData = $event"
              @keyword="onHandleSearch"
              @zIndex="zIndex = $event"
              @checkBoxAll="checkBoxAll"
              @bulkAdd="bulkAddProducts"
            >
              <template slot="checkBoxAll" slot-scope="props">
                <input type="checkbox" :value="props.rowData.sku" v-model="checkedItems" @change="refreshCheckAll" :disabled="props.rowData.amazonQuantity === 0">
              </template>
              <template slot="status" slot-scope="props">
                <span class="box-delivery-judgment-status" :class="getJudgmentStatusClass(props.rowData.status_str)">{{ props.rowData.status_str }}</span>
              </template>
              <template slot="productName" slot-scope="props">
                <div class="flex" style="justify-content: left;">
                  <loading-block :value="props.rowData.image" type="image">
                    <img :src="prepareImgSrc(props.rowData.image)" class="product-img"/>
                  </loading-block>
                  <loading-block :value="props.rowData.itemName" type="string">
                    <a class="text--underline" :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin" target="_blank">
                      {{props.rowData.itemName}}
                    </a>
                    <div><b>ASIN：</b>{{props.rowData.asin}} / <b>SKU：</b>{{ props.rowData.sku }}</div>
                    <div><b>FNSKU：</b>{{props.rowData.fnsku}}</div>
                  </loading-block>
                </div>
              </template>
              <template slot="agentReturnQuantity" slot-scope="props">
                <div v-if="isNaN(props.rowData.agentReturnQuantity)" class="text-gray">{{ props.rowData.agentReturnQuantity }}</div>
                <div v-else>
                  <span class="text-size-20">{{ formatNumber(props.rowData.agentReturnQuantity) }}</span> 個
                </div>
              </template>
              <template slot="amazonQuantity" slot-scope="props">
                <span class="text-size-20">{{ formatNumber(props.rowData.amazonQuantity) }}</span> 個
              </template>
              <template slot="acrossQuantity" slot-scope="props">
                <span class="text-size-20">{{ formatNumber(props.rowData.acrossQuantity) }}</span> 個
              </template>
              <template slot="action" slot-scope="props">
                <button class="btn btn-warning" @click="addProduct(props.rowData)" :disabled="props.rowData.amazonQuantity === 0">追加</button>
              </template>
            </table-delivery-product-add>
            <div class="row m-b-sm">
              <div class="flexbox justify-right">
                <button v-if="checkedItems.length" type="button" class="btn btn-warning btn-add-checked-all mr-r-10" @click="bulkAddProducts()">選択した商品を追加</button>
                <div data-dismiss="modal" @click="$emit('close')">
                  <button class="btn ver-middle w-120">閉じる</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/common/utility'
import TableDeliveryProductAdd from '@/view/warehouseAcross/components/TableDeliveryProductAdd'
import LoadingBlock from '@/components/LoadingBlock'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    deliverySelectedProducts: {
      type: Array,
      default () {
        return []
      }
    },
    apiUrl: {
      type: String,
      default: '/Warehouse/across/delivery/direct/product-available'
    }
  },
  components: {
    TableDeliveryProductAdd,
    LoadingBlock
  },
  data () {
    return {
      error: null,
      loader: null,
      zIndex: null,
      countData: null,
      extraData: null,
      keyword: null,
      deliveryProductColumns: [
        {
          title: '<input type="checkbox" id="checkbox-all">',
          name: 'checkBoxAll',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-30 th-checkbox-all',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'ステータス',
          name: 'status',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '商品情報',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name',
          sortable: false,
          textAlign: 'left',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '<img src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png" class="w-40 mr-r-5" /> FBA長期在庫数',
          name: 'agentReturnQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-180',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'Amazon在庫数',
          name: 'amazonQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-130',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'ACROSS在庫数',
          name: 'acrossQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-130',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-75',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        }
      ],
      checkedItems: []
    }
  },
  computed: {
    iconUrls () {
      return this.$store.getters.getWareHouseIcons
    }
  },
  created () {
    this.loader = this.$loading.show()
  },
  mounted () {
    this.$events.listen('done', (success) => {
      success && $('#delivery-product-add-modal').modal('show')
      this.loader && this.loader.hide()
    })
  },
  methods: {
    formatNumber (number) {
      if (number === null) {
        return '-'
      }
      return Util.formatMoney(number)
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    addProduct (product) {
      this.$emit('handleSelectedProduct', product)
      this.$refs.deliveryProductAddTable.handleData(product, 'delete')
      this.checkedItems = this.checkedItems.filter(sku => sku !== product.sku)
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_add_product_btn,
        properties: {
          asin: product.asin
        }
      }
      EventService.postTrackLog(logParams)
    },
    bulkAddProducts () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_add_products_btn,
        properties: {
          asins: this.checkedItems
        }
      }
      EventService.postTrackLog(logParams)

      let selectedProducts = []
      this.$refs.deliveryProductAddTable.pageData.filter((product) => {
        if (this.checkedItems.includes(product.sku)) {
          selectedProducts.push(product)
        }
      })

      this.$refs.deliveryProductAddTable.handleData(this.checkedItems, 'deleteAll')
      this.checkAll = false
      this.checkedItems = []
      this.$emit('handleSelectedProducts', selectedProducts)
      this.$emit('close')
    },
    onHandleSearch (keywordValue) {
      this.keyword = keywordValue
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_search_btn,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    refreshCheckAll () {
      const items = this.$refs.deliveryProductAddTable.pageData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    checkBoxAll (value) {
      const items = this.$refs.deliveryProductAddTable.pageData
      this.checkAll = value
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          if (item.amazonQuantity === 0) {
            // continue
          } else {
            _self.checkedItems.push(item.sku)
          }
        })
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
#delivery-product-add-modal /deep/ .box-base-table-search {
  display: block;
  justify-content: unset;
  align-items: unset;
  flex-wrap: unset;
}
#delivery-product-add-modal /deep/ .box-base-table-search .search-multiple {
  flex-grow: unset;
  margin-right: unset;
  display: flex;
  align-items: center;
}
#delivery-product-add-modal /deep/ .box-base-table-search .search-multiple input {
  margin-right: 30px;
}
#delivery-product-add-modal /deep/ .th-checkbox-all {
  padding: 6px;
  position: relative;
}
#delivery-product-add-modal /deep/ .th-checkbox-all input {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
}
#delivery-product-add-modal /deep/ .row {
  margin-right: 0px;
  margin-left: 0px;
}
.product-img {
  width: 75px;
}
@media (max-width: 1200px) {
  #delivery-product-add-modal /deep/ .table-wrapper {
    overflow-x: auto;
  }
  #delivery-product-add-modal /deep/ .table-wrapper .table {
    width: max-content;
    max-width: max-content;
  }
  #delivery-product-add-modal /deep/ .product-name {
    width: 500px;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search {
    display: block;
    justify-content: unset;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block {
    display: flex;
    margin-bottom: 10px;
    margin-right: 0;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block label {
    width: 68px;
    margin-right: 0;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block input[name="detail"] {
    width: 184px;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block select[name="mallCode"] {
    width: 184px;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
    margin-left: 68px;
  }
}
@media (min-width: 1200px) {
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/AmazonDeliveryProductAdd.vue